import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

const Container = styled.section`
  padding: 2rem 0 2.4rem;
  margin-bottom: 2.5rem;

  border-bottom: 0.1rem solid ${pickColor('gray')};
`;

const Summary = styled.div`
  margin-bottom: 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2.4rem 3.2rem;

  ${mediaMinWidth.lg(css`
    grid-template-columns: minmax(0, 1fr);
  `)}
`;

const Chart = styled.div`
  min-width: 0;
`;

const ChartTitle = styled.div`
  margin-bottom: 1.2rem;
`;

export { Container, Summary, Grid, Chart, ChartTitle };
